import { Box, useMediaQuery } from '@mui/material'
import gaiaTheme from '../../../../../root-components/theme';
import { PageOuterContainer } from '../../../../../root-components/layouts/page-outer-container';
import { SettingsMobileNavbar } from '../../../../../root-components/navigation/settings-mobile-navbar';
import { PageHeading } from '../../../../presentation-components/display-elements-components/page-heading';
import { ImportDataWizard } from './import-data-wizard';
import { useHasOpenReportPeriod } from '../../../../../hooks/use-has-open-report-period';
import { useContext, useState } from 'react';
import { ReportPeriodContext } from '../../../../../context/report-periods/report-periods';
import { ClosedReportPeriodMessage } from '../../../../presentation-components/miscellaneous-components/closed-report-period-message';
import { StartNewReportPeriodDialog } from '../../../../dialogs/settings/report-period/start-new-report-period-dialog';

export const ImportDataPage = () => {
  //Context
  const reportPeriodContext = useContext(ReportPeriodContext);
  //Hooks 
  const hasOpenReport = useHasOpenReportPeriod([
    reportPeriodContext.allReportPeriods,
    reportPeriodContext.lastSelectedOpenReportId,
  ]);
  //State
  const [openReportPeriodDialogOpen, setOpenReportPeriodDialogOpen] = useState(false);
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  return (
    <PageOuterContainer>
      {isMobileMode && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      <PageHeading
        title='Import data'
        hasTabs={false}
      />
      {hasOpenReport === false ?
        (<ClosedReportPeriodMessage
          openDialog={() => { setOpenReportPeriodDialogOpen(true) }} />)
        :
        hasOpenReport === true ?
          (<ImportDataWizard />)
          :
          null
      }
      {openReportPeriodDialogOpen &&
        <StartNewReportPeriodDialog
          open={openReportPeriodDialogOpen}
          closeHandler={() => { setOpenReportPeriodDialogOpen(false) }}
        />}
    </PageOuterContainer>
  )
}
